export default "__VITE_ASSET__CBemjYhX__"